import { ChantContext } from '../../gregorio-chant/ChantContext';
import { Glyph } from '../glyphs/Glyph';
import { calculateHeightPositionFromPitch } from '../utils';
import { GlyphVisualizer } from '../visualizers';


export class Virgula extends GlyphVisualizer {
  constructor(context: ChantContext, parentheses = false, high = false) {
    super(context, new Glyph(parentheses ? 'VirgulaParenFour' : 'VirgulaFour',
      context.gabcFont, context.gabcGlyphSize), context.gabcColor);

    this.bounds.setY(calculateHeightPositionFromPitch(this._context, high ? 11 : 9));
  }
}
